/* ============================================================================
   Aquarylic Cart Submit Guard
   Version: 1.0.3-mobile-safe
   Purpose:
   - Prevent rapid duplicate Add-to-cart taps/clicks.
   - Never block the first valid submit.
   - Do not globally disable all Add-to-cart buttons.
   - Keep Qikify/Broadcast Add-to-cart flow untouched.
   ============================================================================ */

(function () {
  'use strict';

  if (window.__aqCartSubmitGuardLoaded) return;
  window.__aqCartSubmitGuardLoaded = true;

  var LOCK_DURATION_MS = 1800;
  var locked = false;
  var lockedForm = null;
  var lockedButton = null;
  var unlockTimer = null;
  var initialClickTime = 0;
  var initialClickButton = null;

  var ADD_FORM_SELECTOR = 'form[action*="/cart/add"]';

  var ADD_BUTTON_SELECTOR = [
    'form[action*="/cart/add"] button[type="submit"]',
    'form[action*="/cart/add"] input[type="submit"]',
    'form[action*="/cart/add"] [name="add"]',
    '[data-add-to-cart]',
    '[data-cart-bar-add-to-cart]',
    '.product-form__submit',
    '.product__submit__add',
    '[class*="add-to-cart"]',
    '[class*="AddToCart"]',
    '.qsc2-stickybar__action-btn',
    '.qsc2-btn.qsc2-stickybar__action-btn',
    '.qsc2-stickybar button',
    '.qsc2-stickybar [role="button"]'
  ].join(',');

  function getAddButton(target) {
    if (!target || !target.closest) return null;
    return target.closest(ADD_BUTTON_SELECTOR);
  }

  function getAddFormFromButton(button) {
    if (!button || !button.closest) return null;
    return button.closest(ADD_FORM_SELECTOR);
  }

  function isAddForm(form) {
    return Boolean(form && form.matches && form.matches(ADD_FORM_SELECTOR));
  }

  function getSubmitButtonFromForm(form) {
    if (!form || !form.querySelector) return null;

    return form.querySelector(
      'button[type="submit"], input[type="submit"], [name="add"], [data-add-to-cart], .product-form__submit, .product__submit__add'
    );
  }

  function setButtonBusy(button) {
    if (!button || button.dataset.aqCartGuardBusy === 'true') return;

    button.dataset.aqCartGuardBusy = 'true';
    button.dataset.aqCartGuardOriginalAriaDisabled = button.getAttribute('aria-disabled') || '';
    button.setAttribute('aria-disabled', 'true');

    /*
      Important:
      Do not set button.disabled = true.
      Qikify/Broadcast can rely on the submit button state during async add-to-cart.
      Disabling the element globally caused mobile timing issues.
    */
  }

  function clearButtonBusy(button) {
    if (!button || button.dataset.aqCartGuardBusy !== 'true') return;

    var originalAriaDisabled = button.dataset.aqCartGuardOriginalAriaDisabled;

    if (originalAriaDisabled) {
      button.setAttribute('aria-disabled', originalAriaDisabled);
    } else {
      button.removeAttribute('aria-disabled');
    }

    delete button.dataset.aqCartGuardBusy;
    delete button.dataset.aqCartGuardOriginalAriaDisabled;
  }

  function unlock() {
    locked = false;

    if (lockedButton) {
      clearButtonBusy(lockedButton);
    }

    lockedForm = null;
    lockedButton = null;
    initialClickTime = 0;
    initialClickButton = null;

    if (unlockTimer) {
      window.clearTimeout(unlockTimer);
      unlockTimer = null;
    }

    document.documentElement.classList.remove('aq-cart-add-is-locked');
  }

  function lock(form, button) {
    locked = true;
    lockedForm = form || null;
    lockedButton = button || null;

    document.documentElement.classList.add('aq-cart-add-is-locked');

    if (lockedButton) {
      window.setTimeout(function () {
        setButtonBusy(lockedButton);
      }, 80);
    }

    if (unlockTimer) window.clearTimeout(unlockTimer);
    unlockTimer = window.setTimeout(unlock, LOCK_DURATION_MS);
  }

  function blockDuplicate(event) {
    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
  }

  function isSubmitFromInitialClick(form) {
    if (!initialClickTime || !form) return false;

    var age = Date.now() - initialClickTime;
    if (age > 900) return false;

    if (!initialClickButton) return false;

    var initialForm = getAddFormFromButton(initialClickButton);
    return initialForm === form;
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = getAddButton(event.target);
      if (!button) return;

      var form = getAddFormFromButton(button);

      if (locked) {
        /*
          Only block duplicate clicks for the same form/button.
          Do not globally block other cart systems.
        */
        if (!form || form === lockedForm || button === lockedButton) {
          blockDuplicate(event);
        }

        return;
      }

      initialClickTime = Date.now();
      initialClickButton = button;
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!isAddForm(form)) return;

      if (locked && form === lockedForm && !isSubmitFromInitialClick(form)) {
        blockDuplicate(event);
        return;
      }

      var button = initialClickButton || getSubmitButtonFromForm(form);

      /*
        First valid submit is always allowed.
        Lock only after the event has been allowed to continue.
      */
      window.setTimeout(function () {
        lock(form, button);
      }, 0);
    },
    true
  );

  [
    'theme:product:add',
    'theme:cart:update',
    'theme:cart:change',
    'cart:updated',
    'cart:refresh',
    'ajaxProduct:added',
    'product:added',
    'qikify:cart:updated',
    'qikify:cart:open',
    'aq:cart:updated'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      window.setTimeout(unlock, 250);
    });
  });

  window.addEventListener('pageshow', unlock);
})();